module.exports = __webpack_public_path__ + "img/mi_survey.b3b6380b.svg";